import { render, staticRenderFns } from "./comp10.vue?vue&type=template&id=2fbd43ff&scoped=true"
import script from "./comp10.vue?vue&type=script&lang=ts"
export * from "./comp10.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fbd43ff",
  null
  
)

export default component.exports